import React, { Component } from 'react';
import firebase from '../../store/firebase';
import { showToast } from '../../store/actions/toastAction';
import { connect } from 'react-redux';
//import './csettings.css';
import { SHOW_TOAST, FB_URL } from '../../store/actions/types';
import { Grid, Breadcrumbs, Typography } from '@material-ui/core';
import { withStyles, emphasize } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import Chip from '@material-ui/core/Chip';
import moment from 'moment-timezone';
import axios from 'axios';
import CryptoJS from "crypto-js";

const styles = (theme) => ({
  root: {
    marginTop: 0,
    padding: theme.spacing(1),
    backgroundColor: 'transparent',
    marginLeft: theme.spacing(4), // Move component to the right
  },
  description: {
    fontSize: '16px',
    fontWeight: 500,
    color: theme.palette.text.primary,
    marginRight: theme.spacing(2),
    alignSelf: 'center',
  },
  livebutton: {
    backgroundColor: '#2563eb', 
    color: 'white',
    padding: '8px 16px',
    border: 'none',
    borderRadius: '4px',
    fontSize: '16px',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'backgroundColor 0.2s ease, transform 0.1s ease',
  },
  deadbutton: {
    color: 'white',
    padding: '8px 16px',
    border: 'none',
    borderRadius: '4px',
    fontSize: '16px',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'backgroundColor 0.2s ease, transform 0.1s ease',
    pointerEvents: 'none',
    backgroundColor:'#93c5fd',
    opacity: '0.7',
    cursor: 'not-allowed',
  },
});

const StyledBreadcrumb = withStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.grey[100],
    height: theme.spacing(3),
    color: theme.palette.grey[800],
    fontWeight: theme.typography.fontWeightRegular,
    '&:hover, &:focus': {
      backgroundColor: theme.palette.grey[300],
      textDecoration: 'none',
    },
    '&:active': {
      boxShadow: theme.shadows[1],
      backgroundColor: emphasize(theme.palette.grey[300], 0.12),
      textDecoration: 'none',
    },
  },
}))(Chip);

class cosign extends Component {
  state = {
    coSignData: [],
    loading: true,
    userinSession: this.props.userdata.uid,
    userID: this.props.userdata.userID,
    companyName: this.props.userdata.companyName,    
    firstName: this.props.userdata.firstName,
    lastName:this.props.userdata.lastName,
  };

componentDidMount() {
  // Assuming userinSession is passed as a prop or available in state
  const { userinSession } = this.state; // Adjust based on how you get userinSession
  const COSIGNA = this.decryptUID(process.env.REACT_APP_COSIGNA);
  const COSIGNC = this.decryptUID(process.env.REACT_APP_COSIGNC);

  // Listen for changes in CoSign collection where active is true
  this.coSignRef = firebase.database.ref('CoSign');
  this.coSignRef
    .orderByChild('active')
    .equalTo(true)
    .on('value', (snapshot) => {
      const data = [];
      snapshot.forEach((childSnapshot) => {
        const item = childSnapshot.val();
        // Filter based on userinSession and RequestUid
        console.log('userinSession : ', userinSession);
        if ( 
          (userinSession === COSIGNA && 
           item.RequestUid === COSIGNC) || // Adriaan case
          (userinSession === COSIGNC && 
           item.RequestUid === COSIGNA) // Christo case
        ) {
          data.push({
            id: childSnapshot.key,
            ...item,
          });
        }
      });
      console.log('cosign data: ', data);
      
      this.setState({
        coSignData: data,
        loading: false,
      });
    });
}

  componentWillUnmount() {
    // Clean up listener
    this.coSignRef.off();
  }
////////////////////////////////////////////////////////////////////////////////////
// ──────────────────────────────
//  decryptUID 
// ──────────────────────────────
decryptUID(cipherText) {
  const AES_KEY = "4f9c1fa7ec2f4832973c0f5d2f43b7cc";
  const AES_IV  = "7f4d3b92c3a04f8dac5c59cbf1a4d87f";

  // Fix: Convert URL-safe Base64 → standard Base64
  cipherText = cipherText.replace(/-/g, '+').replace(/_/g, '/');

  const key = CryptoJS.enc.Hex.parse(AES_KEY);
  const iv  = CryptoJS.enc.Hex.parse(AES_IV);

  const cipherParams = {
    ciphertext: CryptoJS.enc.Base64.parse(cipherText)
  };

  const decrypted = CryptoJS.AES.decrypt(cipherParams, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  return decrypted.toString(CryptoJS.enc.Utf8);
}
//////////////////////////////////////////////////////////////////////////////////////
encryptUID(plain) {
  const AES_KEY = "4f9c1fa7ec2f4832973c0f5d2f43b7cc";
  const AES_IV  = "7f4d3b92c3a04f8dac5c59cbf1a4d87f";

  const key = CryptoJS.enc.Hex.parse(AES_KEY);
  const iv  = CryptoJS.enc.Hex.parse(AES_IV);

  const encrypted = CryptoJS.AES.encrypt(plain, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });

  return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
}


/////////////////////////////////////////////////////////////////////////////////////

  handleUpdateMev = async(AllowToSell) => {
    if (AllowToSell !== '') {
        var updates = {};
         updates['/MEVinfo/AllowToSell/'] = Number(AllowToSell);
         
          var res = await axios.post(`${FB_URL}/m115-freshcard`, {
                  params: {
                      updates: updates, //user wallet address                       
                  }
            })

        if (res.data || res.data.success === true) {
          console.log('handleUpdateMev yes:', AllowToSell);
          this.props.showToast({
            type: 'SHOW_TOAST',
            open: true,
            variant: 'success',
            message: `The Max MEV coins anyone can sell now is ${Number(AllowToSell)}`,
          });
        }
        else {
          console.error('handleUpdateMev err:', error);
          this.props.showToast({
            type: 'SHOW_TOAST',
            open: true,
            variant: 'error',
            message: 'Failed to update AllowToSell value',
          });
        }
    } else {
     console.log('handleUpdateMev nv:');
      this.props.showToast({
        type: 'SHOW_TOAST',
        open: true,
        variant: 'error',
        message: 'Please enter a valid number',
      });
    }
  };

  // handleUpdateMev = (AllowToSell) => {
  //   if (AllowToSell !== '') {
  //     firebase
  //       .database
  //       .ref('MEVinfo')
  //       .update({
  //         AllowToSell: Number(AllowToSell),
  //       })
  //       .then(() => {
  //         console.log('Successfully updated AllowToSell:', AllowToSell);
  //         this.props.showToast({
  //           type: 'SHOW_TOAST',
  //           open: true,
  //           variant: 'success',
  //           message: `The Max MEV coins anyone can sell now is ${Number(AllowToSell)}`,
  //         });
  //       })
  //       .catch((error) => {
  //         console.error('Error updating AllowToSell:', error);
  //         this.props.showToast({
  //           type: 'SHOW_TOAST',
  //           open: true,
  //           variant: 'error',
  //           message: 'Failed to update AllowToSell value',
  //         });
  //       });
  //   } else {
  //     console.log('Please enter a valid number');
  //     this.props.showToast({
  //       type: 'SHOW_TOAST',
  //       open: true,
  //       variant: 'error',
  //       message: 'Please enter a valid number',
  //     });
  //   }
  // };

  makeid(length) {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
      for ( var i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * 
  charactersLength));
    }
    return result;
  }

  handleUpdateLc = async(uid, userID, Lc, currpoints, pledge) => {
   const { companyName, firstName, lastName } = this.state;  
   console.log('handleUpdateLc 1: uid: ', uid + ' userID:' + userID + ' Lc:' + Lc + ' currpoints:' + currpoints + ' pledge:' + pledge);

    if (currpoints) {
       var rcurrpoints = currpoints;
       var currLc = rcurrpoints / 100;
    }
    else{
       var rcurrpoints = 0;
       var currLc = 0;
    }

    var updates = {};
    var LcConv = Lc * 100;
    var Lcgiven = Lc;

    var newPoints = Number(rcurrpoints) + Number(LcConv);
    var poe_newPoints = Number(currLc) + Number(Lcgiven);

  let pledgeString;
  switch (pledge) {
    case 1:
      pledgeString = 'Pledge and Lc sent';
      updates[`/users/${userID}/points`] = newPoints;
      updates[`/user/${uid}/points`] = newPoints;  
      updates[`/users/${userID}/pledge`] = LcConv; 
      updates[`/user/${uid}/pledge`] = LcConv;  
      break;

    case 2:
      pledgeString = 'Pledge made';
      updates[`/users/${userID}/pledge`] = LcConv; 
      updates[`/user/${uid}/pledge`] = LcConv;  
      break;

    case 3:
      pledgeString = 'Lc sent';
      updates[`/users/${userID}/points`] = newPoints;
      updates[`/user/${uid}/points`] = newPoints;  
      break;

    default:
      pledgeString = 'Pledge made';
      updates[`/users/${userID}/pledge`] = LcConv; 
      updates[`/user/${uid}/pledge`] = LcConv;  
      console.warn(`Unexpected pledge value: ${pledge}. Defaulting to 'Pledge'`);
      break;
  }

      updates[`/users/${userID}/execmember`] = true;  
      updates[`/user/${uid}/execmember`] = true; 

    if (pledge) {
      if (pledge===1 || pledge===3) { //all Lc related updates happen here
        const trailID = this.makeid(10);
        const timeRaw = moment().tz('Africa/Johannesburg');        
        const timeNowx = timeRaw.format('YYYY-MM-DD HH:mm');          // e.g. 2026-02-12 16:45

        /////////////////////////////////////////////////////////////////////////// 
          const newPaddedDate = timeRaw.format('YYYY/MM/DD'); 
        ///////////////////////////////////////////////////////////////////////////

      updates[`/pointsTrail/${trailID}`] = {
              userID,
              fdate: timeNowx,//timeNow,
              trailID,
              companyName,
              firstName,
              lastName,
              title: pledgeString,
              actionType: pledgeString,
              actionDesc: pledgeString,
              pointsAdded: Lcgiven,
              pointsCurrent: poe_newPoints.toFixed(2),
              gas: 0
            };

          console.log('cosign updates 1: ', updates);

        //UPDATE GIF in patreon field/////////////////////////////////////
        const snap = await firebase.database.ref('patreon').once('value');
         // console.log('cosign updates 1a: ', updates);
        const gifdata = snap.val() || {};
         // console.log('cosign updates 1b: ', gifdata);
        const lcpool  = parseFloat(gifdata.LCPOOL)  || 0;
        const lctoday = parseFloat(gifdata.LCtoday) || 0;
        const addpoints  = parseFloat(LcConv);
        const newLcpool = lcpool - addpoints;
        const newLcToday = (gifdata.Datetoday === newPaddedDate ? lctoday + addpoints : addpoints);
         // console.log('cosign updates 1c: ', LcConv);
        updates['/patreon/Datetoday'] = newPaddedDate;
        updates['/patreon/LCPOOL'] = newLcpool;
        updates['/patreon/LCtoday'] = newLcToday;
                
      updates[`/MEVDATA/${trailID}`] = {
              userID,
              fdate: timeNowx,//timeNow,
              trailID,
              companyName,
              firstName,
              lastName,
              title: pledgeString,
              actionType: pledgeString,
              actionDesc: pledgeString,
              pointsAdded: Lcgiven,
              pointsCurrent: poe_newPoints.toFixed(2),
              gas: 0
            };
          } //all Lc related updates happen here
      /////////////////////////////////////////////////////////

          var res = await axios.post(`${FB_URL}/m115-freshcard`, {
                  params: {
                      updates: updates, //user wallet address                       
                  }
            })

       if (res.data || res.data.success === true) {
          console.log(`${pledgeString} by co-signing`);
        }
        else {
          console.error('Error in giving Lc');
          this.props.showToast({
            type: SHOW_TOAST,
            open: true,
            variant: 'error',
            message: 'Failed to send Lc',
          });
        }
    } else {
      console.log('Please enter a valid number');
      this.props.showToast({
        type: 'SHOW_TOAST',
        open: true,
        variant: 'error',
        message: 'Please enter a valid number',
      });
    }
  };

  handleUpdatePledge = async(uid, userID, Lc, currpoints, pledge, chooseInput) => {
   const { companyName, firstName, lastName } = this.state;  
    if (currpoints) {
       var rcurrpoints = currpoints;
       var currLc = rcurrpoints / 100; //Lc
    }
    else{
       var rcurrpoints = 0;
       var currLc = 0;
    }

    var updates = {};
    var LcConv = Lc * 100;
    //var currLc = currpoints / 100;
    var Lcgiven = Lc;

    var newPoints = Number(rcurrpoints) + Number(LcConv); //points for db
    var poe_newPoints = Number(currLc) + Number(Lcgiven); //Lc for display & data

    if (Lc !== '') {
      if (chooseInput===1) { //admin chose to do pledge and give Lc(points)
        updates[`/users/${userID}/points`] = newPoints;
        updates[`/user/${uid}/points`] = newPoints;
      }
    
      updates[`/users/${userID}/execmember`] = true;
      updates[`/users/${userID}/pledge`] = pledge;

      updates[`/user/${uid}/execmember`] = true;
      updates[`/user/${uid}/pledge`] = pledge;
      /////////////////////////////////////////////////////////
      if (chooseInput===1) { //admin chose to do pledge and give Lc(points)
         const trailID = this.makeid(10);

          const timeRaw = moment().tz('Africa/Johannesburg');        
          const timeNowx = timeRaw.format('YYYY-MM-DD HH:mm');          // e.g. 2026-02-12 16:45

          const newPaddedDate = timeRaw.format('YYYY/MM/DD'); 
        ///////////////////////////////////////////////////////////////////////////
        updates[`/pointsTrail/${trailID}`] = {
              userID,
              fdate: timeNowx,//timeNow,
              trailID,
              companyName,
              firstName,
              lastName,
              title: 'Lc added',
              actionType: 'Proxy Pledge',
              actionDesc: 'Proxy Pledge',
              pointsAdded: Lcgiven,
              pointsCurrent: poe_newPoints.toFixed(2),
              gas: 0
            };

          console.log('cosign updates 1: ', updates);

        //UPDATE GIF in patreon field/////////////////////////////////////
        const snap = await firebase.database.ref('patreon').once('value');
         // console.log('cosign updates 1a: ', updates);
        const gifdata = snap.val() || {};
         // console.log('cosign updates 1b: ', gifdata);
        const lcpool  = parseFloat(gifdata.LCPOOL)  || 0;
        const lctoday = parseFloat(gifdata.LCtoday) || 0;
        const addpoints  = parseFloat(LcConv);
        const newLcpool = lcpool - addpoints;
        const newLcToday = (gifdata.Datetoday === newPaddedDate ? lctoday + addpoints : addpoints);
         // console.log('cosign updates 1c: ', LcConv);
        updates['/patreon/Datetoday'] = newPaddedDate;
        updates['/patreon/LCPOOL'] = newLcpool;
        updates['/patreon/LCtoday'] = newLcToday;
      
        //  console.log('cosign updates 2: ', updates);

        //////////////////////////////////////////////////////////////////////////////           
      updates[`/MEVDATA/${trailID}`] = {
              userID,
              fdate: timeNowx,//timeNow,
              trailID,
              companyName,
              firstName,
              lastName,
              title: 'Lc added',
              actionType: 'Proxy Pledge',
              actionDesc: 'Proxy Pledge',
              pointsAdded: Lcgiven,
              pointsCurrent: poe_newPoints.toFixed(2),
              gas: 0
            };
          } ////admin chose to do pledge and give Lc(points)
      /////////////////////////////////////////////////////////

          var res = await axios.post(`${FB_URL}/m115-freshcard`, {
                  params: {
                      updates: updates, //user wallet address                       
                  }
            })

       if (res.data || res.data.success === true) {
          console.log('The Lc was allocated by co-signing');
          // this.props.showToast({
          //   type: SHOW_TOAST,
          //   open: true,
          //   variant: 'success',
          //   message: `The Lc was allocated by co-signing`,
          // });
        }
        else {
          console.error('Error in giving Lc');
          this.props.showToast({
            type: SHOW_TOAST,
            open: true,
            variant: 'error',
            message: 'Failed to send Lc',
          });
        }
    } else {
      console.log('Please enter a valid number');
      this.props.showToast({
        type: 'SHOW_TOAST',
        open: true,
        variant: 'error',
        message: 'Please enter a valid number',
      });
    }
  };

 UpdateAllPledge = async(uid, userID, Lc, currpoints, pledge, chooseInput) => {
   const { companyName, firstName, lastName } = this.state;  
    if (currpoints) {
       var rcurrpoints = currpoints;
       var currLc = rcurrpoints / 100; //Lc
    }
    else{
       var rcurrpoints = 0;
       var currLc = 0;
    }

    var updates = {};
    var LcConv = Lc * 100;
    var Lcgiven = Lc;

    var newPoints = Number(rcurrpoints) + Number(LcConv); //points for db
    var poe_newPoints = Number(currLc) + Number(Lcgiven); //Lc for display & data

    if (Lc !== '') {
      if (chooseInput===1) { //admin chose to do pledge and give Lc(points)
        updates[`/users/${userID}/points`] = newPoints;
        updates[`/user/${uid}/points`] = newPoints;
      }
    
      updates[`/users/${userID}/execmember`] = true;
      updates[`/users/${userID}/pledge`] = pledge;

      updates[`/user/${uid}/execmember`] = true;
      updates[`/user/${uid}/pledge`] = pledge;
      /////////////////////////////////////////////////////////
      if (chooseInput===1) { //admin chose to do pledge and give Lc(points)
         const trailID = this.makeid(10);

          const timeRaw = moment().tz('Africa/Johannesburg');        
          const timeNowx = timeRaw.format('YYYY-MM-DD HH:mm');          // e.g. 2026-02-12 16:45

          const newPaddedDate = timeRaw.format('YYYY/MM/DD'); 
        ///////////////////////////////////////////////////////////////////////////
        updates[`/pointsTrail/${trailID}`] = {
              userID,
              fdate: timeNowx,//timeNow,
              trailID,
              companyName,
              firstName,
              lastName,
              title: 'Lc added',
              actionType: 'Proxy Pledge',
              actionDesc: 'Proxy Pledge',
              pointsAdded: Lcgiven,
              pointsCurrent: poe_newPoints.toFixed(2),
              gas: 0
            };

          console.log('cosign updates 1: ', updates);

        //UPDATE GIF in patreon field/////////////////////////////////////
        const snap = await firebase.database.ref('patreon').once('value');
         // console.log('cosign updates 1a: ', updates);
        const gifdata = snap.val() || {};
         // console.log('cosign updates 1b: ', gifdata);
        const lcpool  = parseFloat(gifdata.LCPOOL)  || 0;
        const lctoday = parseFloat(gifdata.LCtoday) || 0;
        const addpoints  = parseFloat(LcConv);
        const newLcpool = lcpool - addpoints;
        const newLcToday = (gifdata.Datetoday === newPaddedDate ? lctoday + addpoints : addpoints);
         // console.log('cosign updates 1c: ', LcConv);
        updates['/patreon/Datetoday'] = newPaddedDate;
        updates['/patreon/LCPOOL'] = newLcpool;
        updates['/patreon/LCtoday'] = newLcToday;
      
        //  console.log('cosign updates 2: ', updates);

        //////////////////////////////////////////////////////////////////////////////           
      updates[`/MEVDATA/${trailID}`] = {
              userID,
              fdate: timeNowx,//timeNow,
              trailID,
              companyName,
              firstName,
              lastName,
              title: 'Lc added',
              actionType: 'Proxy Pledge',
              actionDesc: 'Proxy Pledge',
              pointsAdded: Lcgiven,
              pointsCurrent: poe_newPoints.toFixed(2),
              gas: 0
            };
          } ////admin chose to do pledge and give Lc(points)
      /////////////////////////////////////////////////////////

          var res = await axios.post(`${FB_URL}/m115-freshcard`, {
                  params: {
                      updates: updates, //user wallet address                       
                  }
            })

       if (res.data || res.data.success === true) {
          console.log('The Lc was allocated by co-signing');
          // this.props.showToast({
          //   type: SHOW_TOAST,
          //   open: true,
          //   variant: 'success',
          //   message: `The Lc was allocated by co-signing`,
          // });
        }
        else {
          console.error('Error in giving Lc');
          this.props.showToast({
            type: SHOW_TOAST,
            open: true,
            variant: 'error',
            message: 'Failed to send Lc',
          });
        }
    } else {
      console.log('Please enter a valid number');
      this.props.showToast({
        type: 'SHOW_TOAST',
        open: true,
        variant: 'error',
        message: 'Please enter a valid number',
      });
    }
  };

  // UpdateAllPledge_11May = async(uid, userID, Lc, currpoints, pledge, chooseInput) => {
  //  const { companyName, firstName, lastName } = this.state;  
  //   if (currpoints) {
  //      var rcurrpoints = currpoints;
  //      var currLc = rcurrpoints / 100;
  //   }
  //   else{
  //      var rcurrpoints = 0;
  //      var currLc = 0;
  //   }

  //   var updates = {};
  //   var LcConv = Lc * 100;
  //   var Lcgiven = Lc;

  //   var newPoints = Number(rcurrpoints) + Number(LcConv);
  //   var poe_newPoints = Number(currLc) + Number(Lcgiven);

  //   if (Lc !== '') {
  //     updates[`/users/${userID}/points`] = newPoints;
  //     updates[`/users/${userID}/execmember`] = true;
  //     updates[`/users/${userID}/pledge`] = pledge;

  //     updates[`/user/${uid}/points`] = newPoints;  
  //     updates[`/user/${uid}/execmember`] = true;
  //     updates[`/user/${uid}/pledge`] = pledge;
  //     /////////////////////////////////////////////////////////
  //        const trailID = this.makeid(10);

  //         const timeRaw = moment().tz('Africa/Johannesburg');        
  //         const timeNowx = timeRaw.format('YYYY-MM-DD HH:mm');          // e.g. 2026-02-12 16:45

  //         const newPaddedDate = timeRaw.format('YYYY/MM/DD'); 
  //       ///////////////////////////////////////////////////////////////////////////
  //     updates[`/pointsTrail/${trailID}`] = {
  //             userID,
  //             fdate: timeNowx,//timeNow,
  //             trailID,
  //             companyName,
  //             firstName,
  //             lastName,
  //             title: 'Lc added',
  //             actionType: 'Proxy Pledge',
  //             actionDesc: 'Proxy Pledge',
  //             pointsAdded: Lcgiven,
  //             pointsCurrent: poe_newPoints.toFixed(2),
  //             gas: 0
  //           };

  //         console.log('cosign updates 1: ', updates);

  //       //UPDATE GIF in patreon field/////////////////////////////////////
  //       const snap = await firebase.database.ref('patreon').once('value');
  //        // console.log('cosign updates 1a: ', updates);
  //       const gifdata = snap.val() || {};
  //        // console.log('cosign updates 1b: ', gifdata);
  //       const lcpool  = parseFloat(gifdata.LCPOOL)  || 0;
  //       const lctoday = parseFloat(gifdata.LCtoday) || 0;
  //       const addpoints  = parseFloat(LcConv);
  //       const newLcpool = lcpool - addpoints;
  //       const newLcToday = (gifdata.Datetoday === newPaddedDate ? lctoday + addpoints : addpoints);
  //        // console.log('cosign updates 1c: ', LcConv);
  //       updates['/patreon/Datetoday'] = newPaddedDate;
  //       updates['/patreon/LCPOOL'] = newLcpool;
  //       updates['/patreon/LCtoday'] = newLcToday;    

  //       //////////////////////////////////////////////////////////////////////////////           
  //     updates[`/MEVDATA/${trailID}`] = {
  //             userID,
  //             fdate: timeNowx,//timeNow,
  //             trailID,
  //             companyName,
  //             firstName,
  //             lastName,
  //             title: 'Lc added',
  //             actionType: 'Proxy Pledge',
  //             actionDesc: 'Proxy Pledge',
  //             pointsAdded: Lcgiven,
  //             pointsCurrent: poe_newPoints.toFixed(2),
  //             gas: 0
  //           };

  //         var res = await axios.post(`${FB_URL}/m115-freshcard`, {
  //                 params: {
  //                     updates: updates, //user wallet address                       
  //                 }
  //           })

  //      if (res.data || res.data.success === true) {
  //         console.log('The Lc was allocated by co-signing');
  //         // this.props.showToast({
  //         //   type: SHOW_TOAST,
  //         //   open: true,
  //         //   variant: 'success',
  //         //   message: `The Lc was allocated by co-signing`,
  //         // });
  //       }
  //       else {
  //         console.error('Error in giving Lc');
  //         this.props.showToast({
  //           type: SHOW_TOAST,
  //           open: true,
  //           variant: 'error',
  //           message: 'Failed to send Lc',
  //         });
  //       }
  //   } else {
  //     console.log('Please enter a valid number');
  //     this.props.showToast({
  //       type: 'SHOW_TOAST',
  //       open: true,
  //       variant: 'error',
  //       message: 'Please enter a valid number',
  //     });
  //   }
  // };

  updateCoSign = async(idIn) => {
    if (idIn !== '') {
      // firebase
      //   .database
      //   .ref(`CoSign/${idIn}`)
      //   .update({
      //     active: false,
      //   })

        var updates = {};
         updates['/CoSign/' + idIn + '/active/'] = false;
         
          var res = await axios.post(`${FB_URL}/m115-freshcard`, {
                  params: {
                      updates: updates, //user wallet address                       
                  }
            })

        if (res.data || res.data.success === true) {
          console.log('Successfully updated CoSign active status');
          this.props.showToast({
            type: 'SHOW_TOAST',
            open: true,
            variant: 'success',
            message: 'CoSign request approved successfully',
          });
        }
        else {
          console.error('Error updating CoSign:', error);
          this.props.showToast({
            type: 'SHOW_TOAST',
            open: true,
            variant: 'error',
            message: 'Failed to update CoSign status',
          });
        };
    }
  };

  // updateCoSign = (idIn) => {
  //   if (idIn !== '') {
  //     firebase
  //       .database
  //       .ref(`CoSign/${idIn}`)
  //       .update({
  //         active: false,
  //       })
  //       .then(() => {
  //         console.log('Successfully updated CoSign active status');
  //         this.props.showToast({
  //           type: 'SHOW_TOAST',
  //           open: true,
  //           variant: 'success',
  //           message: 'CoSign request approved successfully',
  //         });
  //       })
  //       .catch((error) => {
  //         console.error('Error updating CoSign:', error);
  //         this.props.showToast({
  //           type: 'SHOW_TOAST',
  //           open: true,
  //           variant: 'error',
  //           message: 'Failed to update CoSign status',
  //         });
  //       });
  //   }
  // };

  handleApproveMev = (inputId, AllowToSell) => {
    this.handleUpdateMev(AllowToSell);
    this.updateCoSign(inputId);
  };
  
  handleApproveLc = (inputId, uid, userID, LcGiven, currpoints, pledge) => {
    this.handleUpdateLc(uid, userID, LcGiven, currpoints, pledge);
    this.updateCoSign(inputId);
  };
  handleApproveProxyPledge = (inputId, uid, userID, LcGiven, currpoints, pledge, chooseInput) => {
    this.handleUpdatePledge(uid, userID, LcGiven, currpoints, pledge, chooseInput);
    this.updateCoSign(inputId);
  };

  ApproveALLProxyPledge = async (coSignData) => {
  try {
    const filteredData = coSignData.filter(
      (item) => item.type === "Group proxy Pledge"
    );

    await Promise.all(
      filteredData.map(async (item) => {
        await this.UpdateAllPledge(
          item.targetuid,
          item.targetuserID,
          item.LcGiven,
          item.currpoints,
          item.pledge,
          item.chooseInput,
        );

        await this.updateCoSign(item.id);
      })
    );

    console.log("All proxy pledges processed in parallel");
  } catch (error) {
    console.error("Error processing proxy pledges:", error);
  }
};

  // ApproveALLProxyPledge = (coSignData, inputId, uid, userID, LcGiven, currpoints, pledge) => {
  //   this.UpdateAllPledge(uid, userID, LcGiven, currpoints, pledge);
  //   this.updateCoSign(inputId);
  // };

  render() {
    const { coSignData, loading } = this.state;

    return (
      <div>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12}>
              <Typography variant="h5">CoSign Requests</Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Breadcrumbs aria-label="breadcrumb">
                <StyledBreadcrumb component={Link} to="/companyadmin" label="Club Admin" />
                <StyledBreadcrumb label="Co-Signing" />
              </Breadcrumbs>
            </Grid>
          </Grid>
        {loading ? (
          <p>Loading...</p>
        ) : (
          <div>
       <h6 style={{ textAlign: 'center', marginBottom: '5px' }}>MEV Monthly Limit Co-Sign List</h6>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th style={{ border: '1px solid #ddd', padding: '8px' }}>Type</th>
              <th style={{ border: '1px solid #ddd', padding: '8px' }}>Request</th>
              <th style={{ border: '1px solid #ddd', padding: '8px' }}>Max MEV</th>
              <th style={{ border: '1px solid #ddd', padding: '8px' }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {(() => {
              const filteredData = coSignData.filter((item) => item.type === "mevmax");
              return filteredData.length > 0 ? (
                filteredData.map((item) => (
                  <tr key={item.id}>
                    <td style={{ border: '1px solid #ddd', padding: '8px' }}>{item.type}</td>
                    <td style={{ border: '1px solid #ddd', padding: '8px' }}>{item.RequestPerson}</td>
                    <td style={{ border: '1px solid #ddd', padding: '8px' }}>{item.AllowToSell}</td>
                    <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                      <button
                        onClick={() => this.handleApproveMev(item.id, item.AllowToSell)}
                        style={{
                          padding: '5px 10px',
                          background: '#4CAF50',
                          color: 'white',
                          border: 'none',
                          cursor: 'pointer',
                        }}
                      >
                        APPROVE
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" style={{ textAlign: 'center', padding: '8px' }}>
                    No active CoSign requests
                  </td>
                </tr>
              );
            })()}
          </tbody>
        </table>

       <h6 style={{ textAlign: 'center', marginBottom: '5px' }}>Lc Stipends/Funding Co-Sign List</h6>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
                <th style={{ border: '1px solid #ddd', padding: '8px' }}>Type</th>
                <th style={{ border: '1px solid #ddd', padding: '8px' }}>Request</th>
                <th style={{ border: '1px solid #ddd', padding: '8px' }}>Target</th>
                <th style={{ border: '1px solid #ddd', padding: '8px' }}>Lc add</th>
                <th style={{ border: '1px solid #ddd', padding: '8px' }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {(() => {
             const filteredData = coSignData.filter((item) => item.type === "Pledge and Lc" || item.type === "Pledge"  || item.type === "Lc" );
              return filteredData.length > 0 ? (
                filteredData.map((item) => (
                  <tr key={item.id}>
                      <td style={{ border: '1px solid #ddd', padding: '8px' }}>{item.type}</td>
                      <td style={{ border: '1px solid #ddd', padding: '8px' }}>{item.RequestPerson}</td>
                      <td style={{ border: '1px solid #ddd', padding: '8px' }}>{item.targetname}</td>
                      <td style={{ border: '1px solid #ddd', padding: '8px' }}>{item.LcGiven}</td>
                      <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                      <button
                        onClick={() => this.handleApproveLc(
                          item.id, 
                          item.targetuid,
                          item.targetuserID,
                          item.LcGiven,
                          item.currpoints,
                          item.pledge
                        )}
                        style={{
                          padding: '3px 5px',
                          background: '#4CAF50',
                          color: 'white',
                          border: 'none',
                          cursor: 'pointer',
                        }}
                      >
                        APPROVE
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" style={{ textAlign: 'center', padding: '8px' }}>
                    No active CoSign requests
                  </td>
                </tr>
              );
            })()}
          </tbody>
           <tbody>
            {(() => {
             const filteredData = coSignData.filter((item) => item.type === "pledge");
              return filteredData.length > 0 ? (
                filteredData.map((item) => (
                  <tr key={item.id}>
                      <td style={{ border: '1px solid #ddd', padding: '8px' }}>{item.type}</td>
                      <td style={{ border: '1px solid #ddd', padding: '8px' }}>{item.RequestPerson}</td>
                      <td style={{ border: '1px solid #ddd', padding: '8px' }}>{item.targetname}</td>
                      <td style={{ border: '1px solid #ddd', padding: '8px' }}>{item.LcGiven}</td>
                      <td style={{ border: '1px solid #ddd', padding: '8px' }}>Yes</td>
                      <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                      <button
                        onClick={() => this.handleApproveLc(
                          item.id, 
                          item.targetuid,
                          item.targetuserID,
                          item.LcGiven,
                          item.currpoints,
                          item.pledge
                        )}
                        style={{
                          padding: '3px 5px',
                          background: '#4CAF50',
                          color: 'white',
                          border: 'none',
                          cursor: 'pointer',
                        }}
                      >
                        APPROVE
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" style={{ textAlign: 'center', padding: '8px' }}>
                    No active CoSign requests
                  </td>
                </tr>
              );
            })()}
          </tbody>    
        </table>

        <h6 style={{ textAlign: 'center', marginBottom: '5px' }}>Proxy Group Pledge Co-Sign List</h6>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
                <th style={{ border: '1px solid #ddd', padding: '8px' }}>Type</th>
                <th style={{ border: '1px solid #ddd', padding: '8px' }}>Request</th>
                <th style={{ border: '1px solid #ddd', padding: '8px' }}>Target</th>
                <th style={{ border: '1px solid #ddd', padding: '8px' }}>Lc add</th>
                <th style={{ border: '1px solid #ddd', padding: '8px' }}>Pledge</th> 
                <th style={{ border: '1px solid #ddd', padding: '8px' }}>Action</th>
            </tr>
          </thead>
          <tbody>
{/* APPROVE ALL Row */}
<tr>
  <td 
    colSpan={6}
    style={{ 
      border: '1px solid #ddd', 
      padding: '12px 8px',
      textAlign: 'right'           // fallback
    }}
  >
    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
      <button
        onClick={() => this.ApproveALLProxyPledge(coSignData)}
        style={{
          padding: '3px 14px',
          background: '#c0d12aff',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '12px',
          fontWeight: 'bold'
        }}
      >
        APPROVE ALL
      </button>
    </div>
  </td>
</tr>
            {(() => {
              const filteredData = coSignData.filter((item) => item.type === "Group proxy Pledge");
              return filteredData.length > 0 ? (
                filteredData.map((item) => (
                  <tr key={item.id}>
                      <td style={{ border: '1px solid #ddd', padding: '8px' }}>{item.type}</td>
                      <td style={{ border: '1px solid #ddd', padding: '8px' }}>{item.RequestPerson}</td>
                      <td style={{ border: '1px solid #ddd', padding: '8px' }}>{item.targetname}</td>
                      <td style={{ border: '1px solid #ddd', padding: '8px' }}>{item.LcGiven}</td>
                      <td style={{ border: '1px solid #ddd', padding: '8px' }}>{item.pledge/100}</td>
                      <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                      <button
                        onClick={() => this.handleApproveProxyPledge(
                          item.id, 
                          item.targetuid,
                          item.targetuserID,
                          item.LcGiven,
                          item.currpoints,
                          item.pledge,
                          item.chooseInput
                        )}
                        style={{
                          padding: '3px 5px',
                          background: '#4CAF50',
                          color: 'white',
                          border: 'none',
                          cursor: 'pointer',
                        }}
                      >
                        APPROVE
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" style={{ textAlign: 'center', padding: '8px' }}>
                    No active Group Pledge co-sign requests
                  </td>
                </tr>
              );
            })()}
          </tbody>
        </table>       
          </div>
        )}
      </div>
    );
  }
}


const mapStateToProps = state => {
  return {
    userdata: state.userDialog.userDetails[0],
  }
}

const mapDispatchToProps = (dispatch) => ({
  showToast: (params) => dispatch(showToast(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(cosign));
